import { motion } from 'framer-motion';
import type { Category } from '@/types';

interface CategoryBarProps {
  categories: Category[];
  activeId: number;
  onSelect: (id: number) => void;
  allLabel: string;
}

export function CategoryBar({ categories, activeId, onSelect, allLabel }: CategoryBarProps) {
  const items: Array<{ id: number; name: string }> = [{ id: 0, name: allLabel }, ...categories.map((c) => ({ id: c.id, name: c.name ?? c.slug }))];

  return (
    <nav className="shrink-0 flex gap-2 kiosk:gap-[1.4vw] px-4 kiosk:px-[3vw] py-2 kiosk:py-[1.5vw] overflow-x-auto">
      {items.map((item) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => onSelect(item.id)}
            className={`relative flex-none font-display text-sm kiosk:text-kiosk-sm px-4 py-2 kiosk:px-[2.4vw] kiosk:py-[1.4vw] min-h-[40px] kiosk:min-h-0 rounded-full border transition-colors duration-150 ${
              isActive
                ? 'text-white font-semibold border-kiosk-accent'
                : 'text-kiosk-text bg-kiosk-panel border-kiosk-border'
            }`}
          >
            {isActive && (
              <motion.span
                layoutId="category-pill"
                className="absolute inset-0 rounded-full bg-kiosk-accent"
                transition={{ type: 'spring', stiffness: 400, damping: 32 }}
              />
            )}
            <span className="relative z-10">{item.name}</span>
          </button>
        );
      })}
    </nav>
  );
}
